import React, { useEffect, useState } from "react";

import HttpManager from "../../../../services/HttpManager";
import { BajaDestino, BajaPreviewDTO, EventAttendeeDTO, EventDetailDTO } from "../../../../models/EventDTO";
import S from "./strings";
import { dinero, errorText } from "./comun";

/**
 * Baja (Eventos fase 2, mismo flujo de siempre en forma de «Qué Va a Pasar»): el servidor dice quiénes salen y cuánto pagaron
 * (_bajaPreview, las mismas cuentas que la baja). Con pago: lo pagado, lo que se queda el evento y el sobrante, que hay que mandar
 * a saldo a favor, a cobros pendientes o devolver.
 */
const BajaPanel: React.FC<{ campusId: number; evento: EventDetailDTO; asistente: EventAttendeeDTO; onVolver: () => void; onDone: (texto: string) => void }> = ({ campusId, evento, asistente, onVolver, onDone }) => {
	const http = HttpManager.getInstance();
	const [prev, setPrev] = useState<BajaPreviewDTO | null>(null);
	const [error, setError] = useState<string | null>(null);
	const [destino, setDestino] = useState<BajaDestino | null>(null);
	const [nota, setNota] = useState<string>("");
	const [busy, setBusy] = useState<boolean>(false);

	useEffect(() => {
		let vigente = true;
		http.eventsService.bajaPreview(campusId, asistente.id)
			.then(r => { if (vigente) setPrev(r.data); })
			.catch(e => { if (vigente) setError(errorText(e)); });
		return () => { vigente = false; };
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [campusId, asistente.id]);

	const m = (v: number) => dinero(evento.currency, v);
	const conPago = !!prev && prev.paid > 0.004;
	const sobra = !!prev && prev.surplus > 0.004;
	const bloqueada = !!prev && prev.requiresMoneyRole && !prev.moneyRole;
	const pendientes = prev?.pendingCharges || [];
	const totalPendiente = Math.round(pendientes.reduce((t, c) => t + Number(c.pending || 0), 0) * 100) / 100;
	const notaObligatoria = sobra && destino === "devolucion";
	const valido = !!prev && !bloqueada && (!sobra || !!destino) && (!notaObligatoria || nota.trim().length >= 5);
	const destinos: BajaDestino[] = pendientes.length ? ["saldo", "aplicar", "devolucion"] : ["saldo", "devolucion"];

	const confirmar = () => {
		if (!prev) return;
		setBusy(true); setError(null);
		const d = sobra ? destino || undefined : undefined;
		http.eventsService.removeAttendee(campusId, asistente.id, nota.trim() || undefined, d)
			.then(() => onDone(d ? S.bajaOkDestino(d, m(prev.surplus)) : S.bajaOk))
			.catch(e => { setError(errorText(e)); setBusy(false); });
	};

	return (
		<div className="wevQvp">
			<h6>{S.qvp} · {S.bajaTitulo(asistente.name)}</h6>
			{!prev && !error ? <div className="wevSub">{S.qvpCalculando}</div> : null}
			{prev ? (
				<ul>
					{prev.removed.map(x => <li key={x.id}>{x.name}{x.paid > 0.004 ? ` · ${S.bajaPago} ${m(x.paid)}` : ""}</li>)}
					{conPago && prev.retained > 0.004 ? <li>{S.bajaSeQueda} {m(prev.retained)}</li> : null}
					{sobra ? <li className="wevOro"><b>{S.bajaSobran} {m(prev.surplus)}</b></li> : null}
				</ul>
			) : null}
			{bloqueada ? <div className="error">{S.bajaSoloCaja}</div> : null}
			{prev && !bloqueada && sobra ? (
				<div style={{ marginTop: 8 }}>
					<span className="wevLab">{S.bajaDestino}</span>
					<div className="wau-chips" role="group" aria-label={S.bajaDestino} style={{ marginTop: 4, marginBottom: 6 }}>
						{destinos.map(d => <button key={d} type="button" className="wau-chip" aria-pressed={destino === d} onClick={() => setDestino(d)}>
							{S.destinos[d]}{d === "aplicar" ? <span className="wau-num"> {m(totalPendiente)}</span> : null}</button>)}
					</div>
					{destino === "aplicar" ? <div className="wevSub">{pendientes.map(c => <div key={c.owedArticleId} style={{ display: "flex", justifyContent: "space-between", gap: 10 }}><span>{c.title}</span><span className="wau-num">{m(c.pending)}</span></div>)}</div> : null}
				</div>
			) : null}
			{prev && !bloqueada ? (
				<label className="wau-campo" style={{ marginTop: 8, width: "100%" }}><span className="wau-lab">{notaObligatoria ? S.bajaNotaDevolucion : S.bajaNota}</span>
					<textarea className="wau-entrada" rows={2} maxLength={255} value={nota} onChange={e => setNota(e.target.value)} /></label>
			) : null}
			{error ? <div className="error">{error}</div> : null}
			<div className="acciones">
				<button type="button" className="btn btn-outline-secondary btn-sm" onClick={onVolver} disabled={busy}>{S.volver}</button>
				{prev && !bloqueada ? <button type="button" className="btn btn-primary btn-sm" onClick={confirmar} disabled={busy || !valido}>{busy ? S.guardando : S.baja}</button> : null}
			</div>
		</div>
	);
};

export default BajaPanel;
